import igIcon from "../assets/ig-ic.svg";
import teleIcon from "../assets/tele-ic.svg";
import ytIcon from "../assets/yt-ic.svg";

const mainLinks = [
  { label: "Home", href: "#" },
  { label: "Telegram", href: "/telegram" },
  { label: "Cara Registrasi", to: "/panduan-registrasi" },
];

const socialLinks = [
  { label: "Instagram", href: "https://instagram.com", icon: igIcon },
  { label: "Telegram", href: "https://t.me/arfatradingforex", icon: teleIcon },
  { label: "YouTube", href: "https://youtube.com", icon: ytIcon },
];

const Footer = () => {
  return (
    <footer className="bg-gradient-to-b from-[#050007] via-[#030005] to-black text-white/80 py-16 px-6">
      <div className="mx-auto max-w-6xl space-y-12">
        <div className="grid gap-10 lg:grid-cols-4">
          <div className="space-y-4">
            <img src="/logo.png" alt="ArfaFX" className="h-20 w-auto object-contain" />
            <p className="text-sm text-white/60">
              Perlu bantuan? Hubungi kami 24/7.
            </p>
            <a
              href="https://t.me/arfa_fx"
              className="mt-6 inline-flex items-center justify-center rounded-full bg-[#ff00bf] px-5 py-3 font-semibold text-white shadow-[0_20px_50px_rgba(255,0,191,0.45)] hover:scale-[1.1] transition-transform"
            >
              <img src={teleIcon} alt="" className="h-6 w-auto filter invert" />
              Telegram ArfaFX
            </a>
          </div>

          <div>
            <p className="text-sm font-semibold text-white">Navigasi</p>
            <ul className="mt-4 space-y-2 text-sm text-white/70">
              {mainLinks.map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="hover:text-white transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-sm font-semibold text-white">Ikuti Kami</p>
            <div className="mt-4 flex flex-wrap gap-3">
              {socialLinks.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  aria-label={item.label}
                  className="group inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/20 text-xs font-semibold text-white/80 hover:text-[#ff00bf] hover:border-[#ff00bf] hover:bg-[#ff00bf] transition-colors"
                >
                  <img src={item.icon} alt="" className="h-5 w-5 filter invert opacity-80 transition-opacity group-hover:opacity-100" />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 text-xs text-white/60 flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
          <div className="flex gap-4">
            <a href="#" className="hover:text-white">Terms of Service</a>
            <span>•</span>
            <a href="#" className="hover:text-white">Privacy Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
